import { Box, CircularProgress } from "@mui/material";

type Props = {
  isLoading: boolean | undefined;
}

/**
 * 画面全体で使えるマスク。モーダルとかでも全体を覆える
 * @param root0 コンポーネントのプロップス
 */
export default function Mask({isLoading}: Props) {
  return isLoading ? ( // マスク
    <Box
      sx={{
        position: "absolute",
        inset: 0,
        bgcolor: "rgba(0,0,0,0.2)",
        zIndex: (theme) => theme.zIndex.modal + 1,
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
      }}
    >
      <CircularProgress />
    </Box>
  ) : (
    // eslint-disable-next-line react/jsx-no-useless-fragment
    <></>
  )
}